<template>
    <div>
        <div class="flex borderB padB5">
            <div class="flex mrl20 mrb20 img-box" v-if="type=='add'&&i_isfrom==0">
                <div class="upload-box" v-if="vc_newname==''">
                    <input type="file" name="files" id="uploadfile1"
                           class="upload-input uploadfile1" @change="uploadFile" style="margin-right: 10px"
                    >
                    <el-button size="small" type="primary" :class="baseerp+'btn'" :disabled="isedit"> {{$t('button_upload_attachments')}}</el-button>
                </div>
                <ul  class="uploadPhon flex list" id="formul" v-else>
                    <li class="li-img ale" v-for="(oneimg,index) in formData.files" :key="index">
                        <a
                                :href="file_root+oneimg.vc_path" target="_blank">
                            {{oneimg.vc_name}}
                        </a>
                        <!--<a
                            :download="oneimg.vc_name"
                            mce_href="#"
                            :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+oneimg.filenewname+',deliver\'}','utf-8')">
                            {{oneimg.vc_name}}
                        </a>-->
                        <i class="el-icon-delete" @click="clearFile(oneimg,index)" v-if="isedit==false"></i>
                    </li>
                </ul>
            </div>
            <el-button v-if="type=='edit'" @click="download()" :class="baseerp+'btn'"  size="small" type="primary" >{{$t('invoiceEntry_download_pdf')}}</el-button>
            <div class="flex w33 alc marl4" v-if="i_checkstate!=1">
                <el-radio-group v-model="i_isfrom" :disabled="isedit" @input="changefrom">
                    <el-radio :label="1">{{$t('invoiceEntry_invoice_pool')}}</el-radio>
                    <el-radio :label="0">{{$t('invoiceEntry_invoice_entry')}}</el-radio>
                </el-radio-group>
            </div>
            <el-button v-if="i_checkstate==1&&i_invoiceType==1"  size="small" type="danger" @click="spillover">{{$t('invoiceEntry_write-off_in_red')}}</el-button>
        </div>
        <div :class="type=='add'&&vc_newname==''?'dis':''" v-loading="loading" :element-loading-text="type=='add'&&vc_newname==''?$t('invoiceEntry_please_upload_the_attachment_first_and_then_enter_the_invoice_information'):$t('invoiceEntry_processing_in_progress')">

            <div class="pad15_25">
                <div class="flex w100 marT10">
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_billing_type')}}</span>
                        <el-select style="width: 190px" :disabled="disinput" @change="changeData($event,'fpt')" @clear="clearsearch('fpt')" class="marr4" v-model="vc_type" size="mini" clearable filterable :placeholder="$t('invoiceEntry_please_select_the_billing_type')">
                            <el-option
                                    v-for="item in fpType"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_invoice_type')}}</span>
                        <el-select style="width: 190px" :disabled="disinput" @change="changeData($event,'fplx')" @clear="clearsearch('fplx')" class="marr4" v-model="vc_fptype" size="mini" clearable filterable :placeholder="$t('invoiceEntry_please_select_the_invoice_type')">
                            <el-option
                                    v-for="item in fplxData"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_invoice_code')}}</span>
                        <el-input v-if="i_isfrom==0" @change="resetnote" :disabled="disinput2" style="width: 190px" class="marr4"  v-model="formData.vc_fpcode" :placeholder="$t('invoiceEntry_please_enter_invoice_number')" clearable size="mini"></el-input>
                        <el-select v-else style="width: 190px" :disabled="disinput_fpcode" @change="changeData($event,'code')" @clear="clearsearch('code')" class="marr4" v-model="formData.vc_fpcode" size="mini" clearable filterable :placeholder="$t('invoiceEntry_please_select_the_buyers_option_based_on_the_invoicing_partys_purchase')">
                            <el-option
                                    v-for="item in codeData"
                                    :key="item.vc_fkey"
                                    :label="item.vc_fpcode"
                                    :value="item.vc_fkey">
                            </el-option>
                        </el-select>
                        <i v-if="isred" class="el-icon-zoom-in" @click="opencodes"></i>
                    </div>
                </div>
                <div class="flex w100 marT10">
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_issuer')}}</span>
                        <el-select style="width: 190px" :disabled="disinput" @change="changeData($event,'kpf')" @clear="clearsearch('kpf')" class="marr4" v-model="vc_kpkhname" size="mini" clearable filterable :placeholder="$t('invoiceEntry_please_select_the_invoicing_party')">
                            <el-option
                                    v-for="item in kpfData"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_purchaser')}}</span>
                        <el-select style="width: 190px" :disabled="disinput" @change="changeData($event,'gs')" @clear="clearsearch('gs')" class="marr4" v-model="companyName" size="mini" clearable filterable :placeholder="$t('invoiceEntry_please_select_the_ticketing_company')">
                            <el-option
                                    v-for="item in compsData"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_invoice_time')}}</span>
                        <!--<span class="font14">{{formData.dt_fptime}}</span>-->
                        <el-date-picker
                                :disabled="disinput"
                                style="width: 190px"
                                v-model="formData.dt_fptime"
                                size="mini"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                type="date"
                                :placeholder="$t('form_select_date')"
                                :picker-options="pickerOptions">
                        </el-date-picker>
                    </div>
                </div>
                <div class="flex w100 marT10" v-if="isdk==1">
                    <div class="flex w33 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_is_it_a_proxy_for_opening')}}</span>
                        <el-radio-group v-model="i_isagent" @change="choosedk" :disabled="disinput2">
                            <el-radio :label="1">{{$t('form_correct')}}</el-radio>
                            <el-radio :label="0">{{$t('form_deny')}}</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="flex w33 alc" v-if="i_isagent==1&&isdk==1">
                        <span class="marr4 font14">{{$t('invoiceEntry_seller')}}</span>
                        <el-select  @blur="yanzheng" :disabled="disinput2"  @change="changeData($event,'xs')" @clear="clearsearch('xs')" class="marr4" v-model="xsComname" size="mini" clearable filterable :placeholder="$t('invoiceEntry_please_select_a_sales_company')">
                            <el-option
                                    v-for="item in xsData"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!--<div class="flex w100 marT10 alc" v-if="i_flag==1&&i_isfrom==0">
                    <span class="marr4 font14">币种</span>
                    <el-select  style="width: 190px" :disabled="disinput" @change="changeData($event,'bz')" @clear="clearsearch('bz')" class="marr4" v-model="vc_bzname" size="mini" clearable filterable placeholder="请选择币种">
                        <el-option
                                v-for="item in bzData"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </div>-->
                <div class="flex w100 marT10 alc" v-if="i_origin_khtype==2" >
                    <span class="marr4 font14">{{$t('invoiceEntry_select_order')}}</span>
                    <div class="w100 border pad10" @click="goOrder">{{orderWs}}</div>
                </div>
                <el-table
                        v-if="showTable"
                        ref="table"
                        size="mini"
                        border
                        :data="tableData"
                        height="335"
                        style="width: 100%"
                        class="marT10"
                        :header-cell-style="{background:'#eef1f6',color:'#000'}"
                >
                    <el-table-column
                            type="index"
                            label=""
                            show-overflow-tooltip
                            width="35">
                    </el-table-column>
                    <el-table-column
                            v-if="i_isfrom==1"
                            prop="vc_fppzname"
                            :label="$t('invoiceEntry_invoice_item_name')"
                            show-overflow-tooltip
                            width="250">
                        <template slot-scope="scope">
                            <span class="fppm">{{scope.row.vc_fppzname+' /'+$t('invoiceEntry_specification_model')+'：'+scope.row.vc_fpbzstyle+' /'+$t('form_unit')+'：'+scope.row.vc_fpunit+' /'+$t('form_quantity')+'：'+scope.row.f_fpnum+' /'+$t('form_unit_price')+'：'+scope.row.f_fpprice+' /'+$t('form_amount')+'：'+scope.row.f_fppay_ws+' /'+$t('invoiceEntry_tax_amount')+'：'+scope.row.f_fppay_zzs}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="vc_pzname"
                            :label="$t('invoiceEntry_project_name')"
                            show-overflow-tooltip
                            :width="i_isfrom==1?110:''">
                        <template slot-scope="scope">
                            <el-popover
                                    class="pop"
                                    :id="scope.$index+'pop'"
                                    placement="bottom-end"
                                    width="1000"
                                    trigger="manual"
                                    v-model="scope.row.visible"
                                    style="z-index: 9999">
                                <template>
                                    <product-details v-if="scope.row.visible==true" :productDetails="productDetails" @closePop="closePop(scope.$index)" @transValue="transValue"></product-details>
                                </template>
                                <span slot="reference" @click="openpm(tableData,scope.$index,scope.row)" :class="scope.row.vc_pzname==''?'blue':''">{{scope.row.vc_pzname==''?'['+$t('invoiceEntry_please_select_the_variety')+']':scope.row.vc_pzname+' '+scope.row.vc_cd+scope.row.vc_gykh+scope.row.vc_bzstyle}}</span>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="vc_bzstyle"
                            :label="$t('invoiceEntry_specification_model')"
                            show-overflow-tooltip
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="vc_unit"
                            :label="$t('form_unit')"
                            show-overflow-tooltip
                            width="60">
                    </el-table-column>
                    <el-table-column
                            prop="f_num"
                            :label="$t('form_quantity')"
                            show-overflow-tooltip
                            width="116">
                        <template slot-scope="scope">
                            <el-input-number :disabled="isred" @change="infnum(tableData,scope.$index,scope.row)"  :controls="false" :precision="$setPrecision.quantityPrecision"  :class="i_isfrom==1&&scope.row.f_num!=scope.row.f_fpnum?'red changeinput':'changeinput'" size="mini" v-model="scope.row.f_num" ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_issd==1||i_isagent==1"
                            prop="f_rate"
                            :label="$t('form_exchange_rate')"
                            show-overflow-tooltip
                            width="116">
                        <template slot-scope="scope">
                            <el-input-number :disabled="isred" @change="infrate(tableData,scope.$index,scope.row)"  :controls="false" :min="0" :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini" v-model="scope.row.f_rate" ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_flag==1&&i_isfrom==0"
                            prop="f_price_yb"
                            :label="$t('invoiceEntry_original_currency_unit_price')"
                            show-overflow-tooltip
                            width="95"
                            key="f_price_yb">
                        <template slot-scope="scope">
                            <span>{{scope.row.f_price_yb+scope.row.vc_bzsymbol}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="f_price_ws"
                            :label="$t('invoiceEntry_unit_price_excluding_tax')"
                            show-overflow-tooltip
                            width="85">
                        <template slot-scope="scope">
                            <div :class="i_isfrom==1&&scope.row.f_price_ws!=scope.row.f_fpprice?'red':''">{{scope.row.f_price_ws}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="f_pay_ws"
                            :label="i_isfrom==0&&i_issd==1?$t('invoiceEntry_taxable_amount_including_customs_duties'):$t('invoiceEntry_tax-exempt_amount') "
                            show-overflow-tooltip
                            width="116">
                        <template slot-scope="scope">
                            <el-input-number :disabled="isred" @change="infpay(tableData,scope.$index,scope.row)"   :controls="false"  :precision="2" :class="i_isfrom==1&&scope.row.f_pay_ws!=scope.row.f_fppay_ws?'red changeinput':'changeinput'" size="mini" v-model="scope.row.f_pay_ws" ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_flag==1&&i_isfrom==0"
                            :label="$t('invoiceEntry_tariff')"
                            show-overflow-tooltip
                            width="116">
                        <template slot-scope="scope">
                            <el-input-number :disabled="isred" @change="paygs(tableData,scope.$index,scope.row)"  :controls="false" :min="0" :precision="2" class="changeinput" size="mini" v-model="scope.row.f_pay_gs" ></el-input-number>
                        </template>
                    </el-table-column>

                    <el-table-column
                            prop="f_sl"
                            :label="$t('form_tax_rate')"
                            show-overflow-tooltip
                            width="116">
                        <template slot-scope="scope">
                            <el-input-number :disabled="isred" @change="infsl(tableData,scope.$index,scope.row)"   :controls="false" :min="0" :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini" v-model="scope.row.f_sl" ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="f_pay_zzs"
                            :label="$t('invoiceEntry_tax_amount')"
                            show-overflow-tooltip
                            width="116">
                        <template slot-scope="scope">
                            <el-input-number :disabled="isred" @change="sepay(tableData,scope.$index,scope.row)"   :controls="false"  :precision="2" :class="i_isfrom==1&&scope.row.f_pay_zzs!=scope.row.f_fppay_zzs?'red changeinput':'changeinput'" size="mini" v-model="scope.row.f_pay_zzs" ></el-input-number>

                            <!--                        <span :class="i_isfrom==1&&scope.row.f_pay_zzs!=scope.row.f_fppay_zzs?'red':''">{{scope.row.f_pay_zzs}}</span>-->
                        </template>
                    </el-table-column>
                    <el-table-column  align="center"  width="50" v-if="!isred">
                        <template slot="header" slot-scope="scope" v-if="i_isfrom==0&&i_issd!=1">
                            <el-button class="popaddbtn" @click="popShow"  :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                        </template>
                        <template  slot-scope="scope" v-if="i_issd!=1">
                            <div class="iconminus" v-if="!scope.row.vc_fkey_sub">
                                <!--v-show="!isedit"-->
                                <span class="minus"   @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="flex_b w100 marT10">
                    <div class="flex w50 alc">
                        <span class="marr4 font14">{{$t('invoiceEntry_total_price_and_tax_in_words')}}</span>
                        <span class="marr4 font14">{{DtotalPrice}}</span>
                    </div>
                    <div class="w50 txtE">
                        <span class="marr4 font14">{{'（'+$t('invoiceEntry_lowercase')+'）'+totalPrice}}</span>
                    </div>
                </div>
                <div class="flex w100 marT10 alc">
                    <span class="marr4 font14">{{$t('invoiceEntry_invoice_remarks')}}</span>
                    <el-input class="wid100"  v-model="formData.vc_note">
                    </el-input>
                </div>
                <div class="flex w100 marT10">
                    <div class="w50 alc txt">
                        <span class="w100 marr4 font14">{{$t('invoiceEntry_handler')}}</span>
                        <span class="w100 font14">{{formData.vc_lruname}}</span>
                    </div>
                    <div class="w50 txt">
                        <span class="w100 marr4 font14">{{$t('invoiceEntry_processing_date')}}</span>
                        <span class="w100 font14">{{formData.dt_createtime}}</span>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
                <el-button type="primary" v-if="i_id==0||i_checkstate=='0'"  @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small">{{$t('button_save')}}</el-button>
                <el-button type="danger" v-if="i_id!=0&&i_checkstate=='0'"  @click="tosubmit" :disabled="disabled"  size="small">{{$t('button_submit_for_approval')}}</el-button>
                <el-button @click="cancel(isshua)" size="small">{{$t('button_cancel')}}</el-button>
            </div>
        </div>
        <!--dialog-->
        <el-dialog
                :class="baseerp+'div'"
                width="1000px"
                :title="$t('invoiceEntry_invoice_pool')"
                :visible.sync="dialogVisible_fpc"
                :close-on-click-modal="false"
                @close="cancelDialog_fpc"
                v-if="dialogVisible_fpc"
                :append-to-body="true">
            <fpc-list @cancelDialog_fpc="cancelDialog_fpc"></fpc-list>
        </el-dialog>
        <el-dialog
                :class="baseerp+'div'"
                width="1000px"
                :title="$t('invoiceEntry_order_list')"
                :visible.sync="dialogVisible_order"
                :close-on-click-modal="false"
                @close="cancelDialog_order"
                v-if="dialogVisible_order"
                :append-to-body="true">
            <ord-list :dataOrd="dataOrd" @cancelDialog_order="cancelDialog_order"></ord-list>
        </el-dialog>
        <el-dialog
                :class="baseerp+'div'"
                width="1000px"
                :title="$t('invoiceEntry_related_invoice')"
                :visible.sync="dialogVisible_fpcnew"
                :close-on-click-modal="false"
                @close="cancelDialog_fpcnew"
                v-if="dialogVisible_fpcnew"
                :append-to-body="true">
            <fpc-listnew @cancelDialog_fpcnew="cancelDialog_fpcnew" :fpData="fpData"></fpc-listnew>
        </el-dialog>
    </div>

</template>



<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    import ProductDetails from "./ProductDetails";
    import fpcList from "./fpcList";
    import fpcListnew from "./fpcListnew";
    import ordList from "./ordList";
    export default {
        components: {
            ProductDetails,
            fpcList,
            ordList,
            fpcListnew,
        },
        props:{
            Data:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                copynote:'',
                copyfpcode:'',
                isshua:0,
                fpData:{},
                isred:false,
                i_invoiceType:1,
                vc_relateinvoice_code:'',
                i_glfpid:0,
                loading:true,
                showTable:true,
                orderids:[],
                orderWs:'',
                dataOrd:{},
                vc_newname:"",
                imgList: [],
                imgLength: 0,
                baseerp: "",
                file_url: '',
                file_root:"",
                baseApp:"",
                baseVersion:"",
                erpplatserver:"",
                type:'',
                i_isfrom:0,
                i_id:0,
                fptotalPrice:0,
                totalPrice:0,
                DtotalPrice:'',
                f_pay_ws:0,
                f_pay_zzs:0,
                delIds:[],
                disinput_fpcode:false,//发票code
                disinput2:false,//daikai/xiaoshou
                disinput:false,//禁下拉输入
                disabled:false,//禁保存
                isbtn:false,//禁减号
                isedit:false,//禁单选
                visible:false,
                dialogVisible_fpc:false,
                dialogVisible_fpcnew:false,
                dialogVisible_order:false,
                productDetails:{},
                i_isagent:0,//是否开单
                isdk:0,//是否可开单
                codeData:[],
                vc_fkey:0,
                vc_fpcode:"",
                compsData:[],
                companyName:'',
                companyId:0,
                vc_gscreditcode:"",
                xsData:[],
                xsComname:'',
                xsComId:0,
                kpfData:[],
                i_kpkhid:0,
                vc_kpkhname:'',
                vc_khcreditcode:"",
                fpType:[],
                i_type:0,
                i_khtype:0,
                i_origin_khtype:0,
                vc_fymx:'',
                i_issd:0,
                i_flag:0,
                vc_type:"",
                fplxData:[],
                i_fptype:null,
                vc_fptype:'',
                f_sl:0,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now()  // - 8.64e7;如果要禁用到当前日期则去掉 - 8.64e7
                    },
                },
                formData:{
                    files:[],
                    dt_fptime:'',
                    vc_fpcode:'',
                    vc_lruname:sessionStorage.getItem("lruname"),
                    dt_createtime:'',
                },
                tableData:[],
                yuanshi:[],
                selectD:[],
                details_ord:[],
                disselect:[],
                bzData:[],
                vc_bzname:"",
                i_bzid:0,
                f_rate:0,
                i_checkstate:'',
                i_bzid_yb:0,
            }
        },
        updated() {
            if(this.$refs.table && this.$refs.table.doLayout){
                this.$refs['table'].doLayout();
            }

        },
        watch:{
            i_isfrom(){
                //console.log(this.i_isfrom,'i_isfrom');
                this.refreshTable();
            },
            immediate:true,
            deep:true,
        },
        mounted() {
            this.baseerp = baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.file_root = file_root;
            this.file=this.file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
            //console.log(this.Data,'this.Data');
            this.type=this.Data.type;

            if(this.type=='add'){
                this.getDateYYYYMMddHHMMSS();
                this.fptype();
                this.fplx();
                this.getCompanyList();
                this.DtotalPrice=this.convertToChineseCapital(this.totalPrice);
            };
            if(this.type=='edit'){
                this.loading=false;
                this.i_isfrom=this.Data.row.i_isfrom;
                this.i_issd=this.Data.row.i_issd;
                this.i_flag=this.Data.row.i_flag;
                this.isedit=true;
                this.i_id=this.Data.row.i_id;
                this.isover=this.Data.row.isover;
                this.i_checkstate=this.Data.row.i_checkstate;
                this.$nextTick(()=>{
                    this.detail()
                })
            };
        },
        methods:{
            opencodes(){
                if(this.isred){
                    this.dialogVisible_fpcnew=true;
                }

            },
            spillover(){
                this.isred=true;
                this.disinput2=false;
                this.disinput_fpcode=false;
                this.i_id=0;
                this.copynote=this.formData.vc_note;
                this.copyfpcode=this.formData.vc_fpcode;
                this.formData.vc_fpcode='';
            },
            tosubmit(){
                this.$confirm(this.$t('invoiceEntry_are_you_sure_to_submit_for_approval'), this.$t('tips_prompt'), {
                    confirmButtonText: this.$t('button_sure'),
                    cancelButtonText: this.$t('button_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.submit();
                }).catch(() => {

                });
            },
            async submit(){
                this.loading=true;
                let param = {
                    i_mid:this.mid,
                    i_id:this.i_id,
                };
                //console.log(param,'param')
                //return;
                let res = await API.submit(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.loading=false;
                    this.cancel(1);
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                })
            },
            /*async getbzlist(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.getbzlist(param);
                if (res.code == 1) {
                    this.bzData = res.data.list;
                    this.i_bzid = res.data.list[0].i_id;
                    this.vc_bzname = res.data.list[0].vc_name;
                    this.f_rate = res.data.list[0].f_rate;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },*/
            cancelDialog_order(val){
                this.dialogVisible_order=false;
                if(val){
                    //console.log(val,'val')
                    //console.log(this.details_ord,'this.details_ord')
                    this.i_bzid_yb=val.i_bzid_yb;
                    this.orderWs=val.orderWs;
                    this.orderids=val.ids;
                    //console.log(this.i_isfrom)
                    //console.log(val.details)
                    if(this.i_isfrom==0&&this.i_issd==1){
                        let details = this.deepClone(val.details);
                        //console.log('details',details);
                        //this.disinput=true;
                        //this.disinput2=false;
                        details.map(item=>{
                            item.visible=false;
                            //item.vc_pzname="";
                            //item.f_num=item.f_fpnum;
                            //item.f_price_ws=item.f_fpprice;
                            //item.f_pay_ws=item.f_fppay_ws;
                            //item.f_pay_zzs=item.f_fppay_zzs;
                            //item.f_rate=1;
                            item.f_price_ws=0;
                            item.f_pay_ws=0;
                            item.f_rate=0;
                            item.f_pay_zzs=0;
                            item.f_pay_gs=0;
                            item.f_sl=this.f_sl;
                            item.f_rate=1;
                        })
                        this.tableData=details;
                    }
                    if(this.i_isfrom==1){
                        this.convertUnit(this.details_ord);
                    }
                    /*this.vc_fkey=val.vc_fkey;
                    this.vc_type=val.vc_type;
                    this.i_khtype=val.i_khtype;
                    this.i_isagent=val.i_isagent;
                    this.i_issd=val.i_issd;
                    this.f_sl=val.f_sl;
                    this.i_kpkhid=val.i_kpkhid;
                    this.vc_kpkhname=val.vc_kpkhname;
                    this.vc_khcreditcode=val.vc_khcreditcode;
                    this.companyId=val.companyId;
                    this.companyName=val.companyName;
                    this.vc_gscreditcode=val.vc_gscreditcode;
                    this.beforedetail();*/
                }
            },
            goOrder(){
                //console.log('this.i_isagent',this.i_isagent)
                //console.log('this.xsComId',this.xsComId)
                //console.log('this.i_kpkhid',this.i_kpkhid)
                if(this.i_id!=0&&this.i_checkstate!='0'){
                    return;
                }
                if(this.i_kpkhid==0){
                    this.$message.error(this.$t('invoiceEntry_please_select_the_invoicing_party')+'!');
                    return ;
                }
                if(this.companyId==0){
                    this.$message.error(this.$t('invoiceEntry_please_select_the_buyer')+'!');
                    return ;
                }
                if(this.i_isagent==1&&this.xsComId==0){
                    this.$message.error(this.$t('invoiceEntry_please_select_the_seller')+'!');
                    return ;
                }
                this.dataOrd={
                    i_kpkhid:this.i_isagent==1?this.xsComId:this.i_kpkhid,
                    //i_kpkhid:this.i_kpkhid,
                    i_gsid:this.companyId,
                    selected:this.orderids,
                    disselect:this.disselect,
                    i_issd:this.i_issd,
                    vc_fymx:this.vc_fymx,
                };
                this.dialogVisible_order=true;
            },
            //点击事件
            download(e) {
                let inc = this.vc_newname.includes('http');
                let url = inc?this.vc_newname:this.file_root+this.vc_newname;
                //console.log(url,'url')
                window.open(url,'_blank')
                //window.location.href = this.vc_newname;
                //window.open(this.file_url+'param='+encodeURI('{app:\''+this.baseApp+'\',i_uid:\''+this.i_uid+'\',token:\''+this.token+'\',version:\''+this.baseVersion+'\',fid:\''+this.vc_newname+',invoice\'}','utf-8'))
            },
            clearFile(val,index){
                this.formData.files.splice(index,1);
                this.vc_newname='';
                this.loading=true;
                //this.formData.vc_files.otherfiles.splice(index,1)
                // this.formData.vc_files.otherfiles=[]
                this.$forceUpdate()
            },
            async uploadFile(e) {
                let that = this;
                let i = 0;
                let $files = e.target.files[0];
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];
                if(($files && result==false) || ($files &&result==undefined)){
                    that.$message.error(that.$t('tips_please_upload_a_file_with_the_correct_format'));
                    return;
                };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        // "file": fileId,
                        // "fileName": that.fileName,
                        // "IDtype": "",
                        // "type": 1,
                        "style": "invoicepool",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "invoicepool",
                        "i_appid": 0,
                        // "version": "1.0",
                        // "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname":  sessionStorage.getItem("lruname"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await API.upload(param);
                    if (res.code == 1) {
                        // this.filesImgList.push(res.data[0])
                        // this.filesList.push(res.data[0].i_id)
                        let file={
                            i_id:res.data[0].i_id,
                            vc_name:res.data[0].filename,
                            vc_newname:res.data[0].filenewname,
                            vc_path:res.data[0].vc_path
                        }
                        /*this.formData.vc_files.otherfiles.push(file)*/
                        this.formData.files.push(file);
                        this.vc_newname=res.data[0].vc_path;
                        //console.log(this.vc_newname,'this.vc_newname')
                        this.loading=false;
                        this.$forceUpdate()
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },
            resetnote(){
                this.formData.vc_note=this.copynote+';'+this.$t('invoiceEntry_invoice_number_with_red_and_blue_characters')+':'+this.copyfpcode+';'+this.$t('invoiceEntry_red_invoice_information_confirmation_form_number')+':'+this.formData.vc_fpcode;
            },
            cancelDialog_fpcnew(val){
                this.dialogVisible_fpcnew=false;
                //console.log(val,'val')
                if(val){
                    this.i_invoiceType=2;
                    this.tableData.map(item=>{
                        item.f_num=item.f_num*-1
                        item.f_pay_ws=item.f_pay_ws*-1
                        item.f_pay_zzs=item.f_pay_zzs*-1
                    })
                    //价税合计
                    let tp = 0;
                    let ts = 0;
                    this.tableData.map(item=>{
                        tp += item.f_pay_ws;
                        ts += item.f_pay_zzs;
                    })
                    this.f_pay_ws= parseFloat(this.keepTwoDecimal(tp));
                    this.f_pay_zzs= parseFloat(this.keepTwoDecimal(ts));
                    //this.totalPrice = parseFloat(this.keepTwoDecimal(tp)) + parseFloat(this.keepTwoDecimal(ts));
                    //this.totalPrice = parseFloat(this.keepTwoDecimal(tp+ts));
                    let num = this.keepTwoDecimal(tp+ts);
                    this.totalPrice = this.returnFloat(num);
                    this.DtotalPrice = '负'+this.convertToChineseCapital(this.totalPrice*-1);
                    if(val.i_isfrom==1){
                        this.disinput_fpcode=false;
                        //console.log('关联发票')
                    }else{
                        this.disinput2=false;
                        //console.log('上传')
                    }
                    this.formData.files=val.files;
                    this.vc_newname=val.vc_newname;
                    this.formData.vc_fpcode=val.vc_fpcode;
                    this.formData.vc_note=this.copynote+';'+this.$t('invoiceEntry_invoice_number_with_red_and_blue_characters')+':'+this.copyfpcode+';'+this.$t('invoiceEntry_red_invoice_information_confirmation_form_number')+':'+this.formData.vc_fpcode;
                    /*this.vc_fkey=val.vc_fkey;
                    this.vc_type=val.vc_type;
                    this.i_khtype=val.i_khtype;
                    this.i_origin_khtype=val.i_origin_khtype;
                    this.vc_fymx=val.vc_fymx;
                    //this.i_isagent=val.i_isagent;
                    this.isdk=val.i_dkable;
                    this.i_type=val.i_type;
                    this.i_issd=val.i_issd;
                    this.i_flag=val.i_flag;
                    this.f_sl=val.f_sl;
                    this.i_kpkhid=val.i_kpkhid;
                    this.vc_kpkhname=val.vc_kpkhname;
                    this.vc_khcreditcode=val.vc_khcreditcode;
                    this.companyId=val.companyId;
                    this.companyName=val.companyName;
                    this.vc_gscreditcode=val.vc_gscreditcode;
                    this.details_ord=val.form.details;
                    this.beforedetail(val.form);*/
                    /*if(this.i_flag==1&&this.i_isfrom==0){
                        this.getbzlist();
                    }*/
                }else{
                    this.isred=false;
                    this.i_invoiceType=1;
                }
            },
            cancelDialog_fpc(val){
                this.dialogVisible_fpc=false;
                if(val){
                    this.vc_fkey=val.vc_fkey;
                    this.vc_type=val.vc_type;
                    this.i_khtype=val.i_khtype;
                    this.i_origin_khtype=val.i_origin_khtype;
                    this.vc_fymx=val.vc_fymx;
                    //this.i_isagent=val.i_isagent;
                    this.isdk=val.i_dkable;
                    this.i_type=val.i_type;
                    this.i_issd=val.i_issd;
                    this.i_flag=val.i_flag;
                    this.f_sl=val.f_sl;
                    this.i_kpkhid=val.i_kpkhid;
                    this.vc_kpkhname=val.vc_kpkhname;
                    this.vc_khcreditcode=val.vc_khcreditcode;
                    this.companyId=val.companyId;
                    this.companyName=val.companyName;
                    this.vc_gscreditcode=val.vc_gscreditcode;
                    this.details_ord=val.form.details;
                    this.beforedetail(val.form);
                    /*if(this.i_flag==1&&this.i_isfrom==0){
                        this.getbzlist();
                    }*/
                }
            },
            changefrom(e){
                //console.log('e',e)
                this.i_isfrom=e;
                this.i_isagent=0;
                this.formData.vc_fpcode='';
                this.formData.dt_fptime="";
                this.formData.files=[];
                this.tableData=[];
                this.delIds=[];
                this.productDetails={};
                this.vc_newname='';
                this.disinput_fpcode=false;
                this.disinput2=false;//daikai/xiaoshou
                this.disinput=false;//禁下拉输入
                this.disabled=false;//禁保存
                this.isbtn=false;//禁减号
                this.isedit=false;//禁单选
                if(e==1){
                    this.loading=false;
                    this.i_flag=0;
                    this.dataOrd={};
                    this.orderWs='';
                    this.orderids=[];
                    this.vc_fkey=0;
                    this.vc_fpcode="";
                    this.dialogVisible_fpc=true;
                }else{
                    this.loading=true;
                }


            },
            /*openfpc(){
                this.vc_fkey=0;
                this.vc_fpcode="";
                this.dialogVisible_fpc=true;
            },*/
            //根据开票方获取发票编号列表-获取详情
            async beforedetail(form){
                let form1 = this.deepClone(form)
                //console.log('form',form1)
                this.disinput_fpcode=true;
                this.disinput=true;
                this.disinput2=false;
                form1.details.map(item=>{
                    item.visible=false;
                    item.vc_pzname="";
                    item.f_num=item.f_fpnum;
                    item.f_price_ws=item.f_fpprice;
                    item.f_pay_ws=item.f_fppay_ws;
                    item.f_pay_zzs=item.f_fppay_zzs;
                    item.f_rate=1;
                })
                this.tableData=form1.details;
                this.formData= form1;
                //console.log('this.tableData--',this.tableData);
                this.i_id=form1.i_id;
                this.vc_fkey=form1.vc_fkey;
                this.fptotalPrice=form1.f_pay;
                this.totalPrice=form1.f_pay;
                //this.DtotalPrice=form1.vc_capitalpay;
                this.DtotalPrice=this.convertToChineseCapital(form1.f_pay);
                this.f_pay_ws=form1.f_pay_ws;
                this.f_pay_zzs=form1.f_pay_zzs;
                this.companyName=form1.vc_gsname;
                //this.companyId=form1.i_gsid;
                this.vc_gscreditcode=form1.vc_gscreditcode;
                this.xsComname=form1.i_isagent==1?form1.vc_kpkhname:'';
                this.xsComId=form1.i_isagent==1?form1.i_kpkhid:0;
                //this.i_kpkhid=form1.i_isagent==1?form1.i_dlkhid:form1.i_kpkhid;
                this.vc_kpkhname=form1.i_isagent==1?form1.vc_dlkhname:form1.vc_kpkhname;
                this.vc_khcreditcode=form1.vc_khcreditcode;
                //this.i_type=form1.i_type;
                //this.i_fptype=form1.i_fptype;
                this.vc_fptype=form1.vc_fptype;
                let chofptype = this.fplxData.filter(item=>{
                    return item.vc_name == this.vc_fptype
                })
                //console.log('chofptype',chofptype)
                if(chofptype.length!=0){
                    this.i_fptype=chofptype[0].i_id;
                }else{
                    this.vc_fptype='';
                    this.i_fptype=0;
                };
                this.yuanshi = this.deepClone(this.tableData).filter(item=>(item.vc_pzname==''))
                //console.log(this.yuanshi,'yuanshi')
                this.vc_newname=form1.vc_mainfile_newname;
                /*let param={
                    vc_fkey:this.vc_fkey,
                };
                let res=await API.beforedetail(param);
                if(res.code==1){
                    this.disinput=true;
                    this.disinput2=false;
                    res.data.details.map(item=>{
                        item.visible=false;
                        item.vc_pzname="";
                        item.f_num=item.f_fpnum;
                        item.f_price_ws=item.f_fpprice;
                        item.f_pay_ws=item.f_fppay_ws;
                        item.f_pay_zzs=item.f_fppay_zzs;
                        item.f_rate=1;
                    })
                    this.tableData=res.data.details;
                    this.formData=res.data;
                    console.log('this.tableData--',this.tableData);
                    this.i_id=res.data.i_id;
                    this.vc_fkey=res.data.vc_fkey;
                    this.fptotalPrice=res.data.f_pay;
                    this.totalPrice=res.data.f_pay;
                    //this.DtotalPrice=res.data.vc_capitalpay;
                    this.DtotalPrice=this.convertToChineseCapital(res.data.f_pay);
                    this.f_pay_ws=res.data.f_pay_ws;
                    this.f_pay_zzs=res.data.f_pay_zzs;
                    this.companyName=res.data.vc_gsname;
                    //this.companyId=res.data.i_gsid;
                    this.vc_gscreditcode=res.data.vc_gscreditcode;
                    this.xsComname=res.data.i_isagent==1?res.data.vc_kpkhname:'';
                    this.xsComId=res.data.i_isagent==1?res.data.i_kpkhid:0;
                    //this.i_kpkhid=res.data.i_isagent==1?res.data.i_dlkhid:res.data.i_kpkhid;
                    this.vc_kpkhname=res.data.i_isagent==1?res.data.i_dlkhname:res.data.vc_kpkhname;
                    this.vc_khcreditcode=res.data.vc_khcreditcode;
                    //this.i_type=res.data.i_type;
                    //this.i_fptype=res.data.i_fptype;
                    this.vc_fptype=res.data.vc_fptype;
                    let chofptype = this.fplxData.filter(item=>{
                        return item.vc_name == this.vc_fptype
                    })
                    console.log('chofptype',chofptype)
                    if(chofptype.length!=0){
                        this.i_fptype=chofptype[0].i_id;
                    }else{
                        this.vc_fptype='';
                        this.i_fptype=0;
                    };

                    this.yuanshi = this.deepClone(this.tableData).filter(item=>(item.vc_pzname==''))
                    console.log(this.yuanshi,'yuanshi')
                    this.vc_newname=res.data.vc_mainfile_newname;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }*/

            },
            // 单位换算
            async convertUnit(details){
                //console.log('this.i_isagent',this.i_isagent)
                //console.log('this.xsComId',this.xsComId)
                //console.log('this.i_kpkhid',this.i_kpkhid)
                let param={
                    vc_no:this.orderWs,
                    i_khtype:this.i_isagent==1?2:this.i_khtype,
                    //i_kpkhid:this.i_kpkhid,
                    i_kpkhid:this.i_isagent==1?this.xsComId:this.i_kpkhid,
                    details:details,
                };
                let res=await API.convertUnit(param);
                if(res.code==1){
                    this.disinput_fpcode=true;
                    this.disinput=true;
                    this.disinput2=false;
                    res.data.list.map(item=>{
                        item.visible=false;
                        //item.vc_pzname="";
                        item.f_num=item.vc_pzname==""?item.f_fpnum:item.f_num;
                        item.f_price_ws=item.vc_pzname==""?item.f_fpprice:item.f_price_ws;
                        item.f_pay_ws=item.f_fppay_ws;
                        item.f_pay_zzs=item.f_fppay_zzs;
                        item.f_rate=1;
                    })
                    this.tableData=res.data.list;
                    /*this.formData=res.data;
                    console.log('this.tableData--',this.tableData);
                    this.i_id=res.data.i_id;
                    this.vc_fkey=res.data.vc_fkey;
                    this.fptotalPrice=res.data.f_pay;
                    this.totalPrice=res.data.f_pay;
                    //this.DtotalPrice=res.data.vc_capitalpay;
                    this.DtotalPrice=this.convertToChineseCapital(res.data.f_pay);
                    this.f_pay_ws=res.data.f_pay_ws;
                    this.f_pay_zzs=res.data.f_pay_zzs;
                    this.companyName=res.data.vc_gsname;
                    //this.companyId=res.data.i_gsid;
                    this.vc_gscreditcode=res.data.vc_gscreditcode;
                    this.xsComname=res.data.i_isagent==1?res.data.vc_kpkhname:'';
                    this.xsComId=res.data.i_isagent==1?res.data.i_kpkhid:0;
                    //this.i_kpkhid=res.data.i_isagent==1?res.data.i_dlkhid:res.data.i_kpkhid;
                    this.vc_kpkhname=res.data.i_isagent==1?res.data.vc_dlkhname:res.data.vc_kpkhname;
                    this.vc_khcreditcode=res.data.vc_khcreditcode;
                    //this.i_type=res.data.i_type;
                    //this.i_fptype=res.data.i_fptype;
                    this.vc_fptype=res.data.vc_fptype;
                    let chofptype = this.fplxData.filter(item=>{
                        return item.vc_name == this.vc_fptype
                    })
                    console.log('chofptype',chofptype)
                    if(chofptype.length!=0){
                        this.i_fptype=chofptype[0].i_id;
                    }else{
                        this.vc_fptype='';
                        this.i_fptype=0;
                    };

                    this.yuanshi = this.deepClone(this.tableData).filter(item=>(item.vc_pzname==''))
                    console.log(this.yuanshi,'yuanshi')
                    this.vc_newname=res.data.vc_mainfile_newname;*/
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //获取详情
            async detail(){
                let param={
                    i_id:this.i_id,
                    vc_fkey:'',
                    //isover:this.isover,
                };
                let res=await API.detail(param);
                if(res.code==1){
                    this.disinput_fpcode=true;
                    this.disinput=true;
                    this.disinput2=true;
                    this.details_ord=res.data.details;
                    this.formData=res.data;
                    this.i_isfrom=res.data.i_isfrom;
                    res.data.details.map(item=>{
                        item.visible=false;
                    })
                    this.tableData=res.data.details;
                    this.i_id=res.data.i_id;
                    this.i_checkstate=res.data.i_checkstate;
                    this.totalPrice=res.data.f_pay;
                    this.fptotalPrice=res.data.f_pay;
                    this.DtotalPrice=res.data.vc_capitalpay;
                    //this.DtotalPrice=this.convertToChineseCapital(res.data.f_pay);
                    this.f_pay_ws=res.data.f_pay_ws;
                    this.f_pay_zzs=res.data.f_pay_zzs;
                    this.i_isagent=res.data.i_isagent;
                    this.isdk=res.data.i_dkable;
                    this.companyName=res.data.vc_gsname;
                    this.companyId=res.data.i_gsid;
                    this.vc_gscreditcode=res.data.vc_gscreditcode;
                    this.xsComname=res.data.i_isagent==1?res.data.vc_kpkhname:'';
                    this.xsComId=res.data.i_isagent==1?res.data.i_kpkhid:0;
                    this.i_kpkhid=res.data.i_isagent==1?res.data.i_dlkhid:res.data.i_kpkhid;
                    this.vc_kpkhname=res.data.i_isagent==1?res.data.vc_dlkhname:res.data.vc_kpkhname;
                    this.vc_khcreditcode=res.data.vc_khcreditcode;
                    this.i_type=res.data.i_type;
                    this.vc_type=res.data.typeTxt;
                    this.i_fptype=res.data.i_fptype;
                    this.vc_fptype=res.data.vc_fptype;
                    this.vc_newname=res.data.vc_mainfile_newname;
                    this.orderWs=res.data.vc_no;
                    this.disselect=res.data.vc_no.split(',');
                    //console.log(this.disselect)
                    this.i_origin_khtype=res.data.i_origin_khtype;
                    this.vc_fymx=res.data.vc_fymx;
                    this.i_issd=res.data.i_issd;
                    this.i_flag=res.data.i_flag;
                    this.i_invoiceType=res.data.i_invoiceType;
                    this.vc_relateinvoice_code=res.data.vc_relateinvoice_code?res.data.vc_relateinvoice_code:null;
                    this.i_glfpid=res.data.i_glfpid;
                    this.fpData={
                        name:'spill',
                        i_isfrom:res.data.i_isfrom,
                        i_type:res.data.i_type,
                        vc_type:res.data.typeTxt,
                        i_kpkhid:res.data.i_kpkhid,
                        vc_kpkhname:res.data.vc_kpkhname,
                        vc_khcreditcode:res.data.vc_khcreditcode,
                        companyId:res.data.i_gsid,
                        companyName:res.data.vc_gsname,
                        vc_gscreditcode:res.data.vc_gscreditcode,
                    }

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            sepay(data,index,row){
                if(row.f_pay_zzs < 0){
                    this.$message.error(this.$t('invoiceEntry_the_tax_amount_cannot_be_less_than_0'));
                    return ;
                }else{
                    let cenzzs = row.f_pay_ws * row.f_sl;
                    cenzzs = parseFloat(this.keepTwoDecimal(cenzzs));
                    //console.log(cenzzs,'cenzzs')
                    let more = cenzzs+1;
                    let less = cenzzs-1<0?0:(cenzzs-1);
                    //console.log(more,'more')
                    //console.log(less,'less')
                    if(row.f_pay_zzs<less||row.f_pay_zzs>more){
                        this.$nextTick(()=>{
                            row.f_pay_zzs = cenzzs;
                        })
                        this.$message.error(this.$t('invoiceEntry_the_tax_amount_must_not_exceed_or_be_less_than_the_established_tax_amount_by_more_than')+cenzzs+"±1！");
                    }
                    this.$nextTick(()=>{
                        //价税合计
                        let tp = 0;
                        let ts = 0;
                        data.map(item=>{
                            tp += item.f_pay_ws;
                            ts += item.f_pay_zzs;
                        });
                        this.f_pay_ws= parseFloat(this.keepTwoDecimal(tp));
                        this.f_pay_zzs= parseFloat(this.keepTwoDecimal(ts));
                        //this.totalPrice = parseFloat(this.keepTwoDecimal(tp)) + parseFloat(this.keepTwoDecimal(ts));
                        //this.totalPrice = parseFloat(this.keepTwoDecimal(tp+ts));
                        let num = this.keepTwoDecimal(tp+ts);
                        this.totalPrice = this.returnFloat(num);
                        this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                    })
                }
            },
            infrate(data,index,row){
                //判断完税价格正负一
                let wsprice = (row.f_price_yb * row.f_num * row.f_rate)+row.f_pay_gs;
                    wsprice = parseFloat(this.keepTwoDecimal(wsprice));
                //console.log(wsprice,'wsprice')
                let more = wsprice+1;
                let less = wsprice-1;
                //console.log(more,'more');
                //console.log(less,'less');
                if(row.f_pay_ws<less||row.f_pay_ws>more){
                    this.$nextTick(()=>{
                        row.f_pay_ws = wsprice;
                    })
                    this.$message.error(this.$t('invoiceEntry_the_dutiable_value_shall_not_exceed_or_be_less_than_the_established_price')+wsprice+"±1！");
                }
                //价税合计
                let tp = 0;
                let ts = 0;
                data.map(item=>{
                    tp += item.f_pay_ws;
                    ts += item.f_pay_zzs;
                })
                this.f_pay_ws= parseFloat(this.keepTwoDecimal(tp));
                this.f_pay_zzs= parseFloat(this.keepTwoDecimal(ts));
                //this.totalPrice = parseFloat(this.keepTwoDecimal(tp)) + parseFloat(this.keepTwoDecimal(ts));
                //this.totalPrice = parseFloat(this.keepTwoDecimal(tp+ts));
                let num = this.keepTwoDecimal(tp+ts);
                this.totalPrice = this.returnFloat(num);
                this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
            },
            infsl(data,index,row){
                let fzzs = row.f_pay_ws * row.f_sl;
                    fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                row.f_pay_zzs = fzzs;
                this.$set(data,index,row);
                //价税合计
                let tp = 0;
                let ts = 0;
                data.map(item=>{
                    tp += item.f_pay_ws;
                    ts += item.f_pay_zzs;
                });
                this.f_pay_ws= parseFloat(this.keepTwoDecimal(tp));
                //console.log(this.f_pay_ws)
                this.f_pay_zzs= parseFloat(this.keepTwoDecimal(ts));
                //console.log(this.f_pay_zzs)
                //this.totalPrice = parseFloat(this.keepTwoDecimal(tp)) + parseFloat(this.keepTwoDecimal(ts));
                //this.totalPrice = parseFloat(this.keepTwoDecimal(tp+ts));
                let num = this.keepTwoDecimal(tp+ts);
                this.totalPrice = this.returnFloat(num);
                //console.log(this.totalPrice);
                this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);

                /*let totalP = this.totalPrice
                    totalP = parseFloat(this.buzero(totalP))
                console.log(totalP,'totalP')*/
            } ,
            infnum(data,index,row){
                //console.log(this.tableData);
                //console.log('index',index)
                //console.log(row,'row')
                if(row.f_num <= 0){
                    this.$message.error(this.$t('invoiceEntry_the_quantity_must_not_be_less_than_or_equal_to_0'));
                    return ;
                }else{
                    if(this.i_isfrom==0&&this.i_issd==1){
                        if(row.f_pay_ws!=0){
                            let wsprice = row.f_pay_ws - row.f_pay_gs
                            let price = this.preciseDiv(wsprice, row.f_num);
                                price = parseFloat(this.keepTwoDecimal(price));
                            row.f_price_ws = price;
                            this.$set(data,index,row);
                            //价税合计
                            let tp = 0;
                            let ts = 0;
                            data.map(item=>{
                                tp += item.f_pay_ws;
                                ts += item.f_pay_zzs;
                            });
                            this.f_pay_ws= parseFloat(this.keepTwoDecimal(tp));
                            this.f_pay_zzs= parseFloat(this.keepTwoDecimal(ts));
                            //this.totalPrice = parseFloat(this.keepTwoDecimal(tp)) + parseFloat(this.keepTwoDecimal(ts));
                            //this.totalPrice = parseFloat(this.keepTwoDecimal(tp+ts));
                            let num = this.keepTwoDecimal(tp+ts);
                            this.totalPrice = this.returnFloat(num);
                            this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                        }
                    }else{
                        if(row.f_pay_ws!=0){
                            let price = this.preciseDiv(row.f_pay_ws, row.f_num);
                                price = parseFloat(this.keepTwoDecimal(price));
                            row.f_price_ws = price;
                            this.$set(data,index,row);
                            //价税合计
                            let tp = 0;
                            let ts = 0;
                            data.map(item=>{
                                tp += item.f_pay_ws;
                                ts += item.f_pay_zzs;
                            });
                            this.f_pay_ws= parseFloat(this.keepTwoDecimal(tp));
                            this.f_pay_zzs= parseFloat(this.keepTwoDecimal(ts));
                            //this.totalPrice = parseFloat(this.keepTwoDecimal(tp)) + parseFloat(this.keepTwoDecimal(ts));
                            //this.totalPrice = parseFloat(this.keepTwoDecimal(tp+ts));
                            let num = this.keepTwoDecimal(tp+ts);
                            this.totalPrice = this.returnFloat(num);
                            this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                        }
                    }

                }
            },
            paygs(data,index,row){
                if(row.f_pay_ws!=0){
                    //let payws = row.f_pay_ws+row.f_pay_gs;
                    //console.log(payws,'完税-关税')
                    let wsprice = (row.f_price_yb * row.f_num * row.f_rate)+row.f_pay_gs;
                        wsprice = parseFloat(this.keepTwoDecimal(wsprice));
                    //console.log(wsprice,'wsprice-infpay')
                    row.f_pay_ws = wsprice;
                    let payws = row.f_pay_ws-row.f_pay_gs;
                    let price = this.preciseDiv(payws, row.f_num);
                        price = parseFloat(this.keepTwoDecimal(price));
                    row.f_price_ws = price;
                    let fzzs = row.f_pay_ws * row.f_sl;
                        fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                    row.f_pay_zzs = fzzs;
                    this.$set(data,index,row);
                    //价税合计
                    let tp = 0;
                    let ts = 0;
                    data.map(item=>{
                        tp += item.f_pay_ws;
                        ts += item.f_pay_zzs;
                    })
                    this.f_pay_ws= parseFloat(this.keepTwoDecimal(tp));
                    this.f_pay_zzs= parseFloat(this.keepTwoDecimal(ts));
                    //this.totalPrice = parseFloat(this.keepTwoDecimal(tp)) + parseFloat(this.keepTwoDecimal(ts));
                    //this.totalPrice = parseFloat(this.keepTwoDecimal(tp+ts));
                    let num = this.keepTwoDecimal(tp+ts);
                    this.totalPrice = this.returnFloat(num);
                    this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                }
            },
            infpay(data,index,row){
                //console.log(row,'infpay');
                if(row.f_pay_ws <= 0){
                    this.$message.error(this.$t('invoiceEntry_the_amount_cannot_be_less_than_or_equal_to_0'));
                    return ;
                }else{
                    if(this.i_isfrom==0&&this.i_issd==1){
                        if(row.f_pay_ws!=0){
                            //判断完税价格正负一
                            let wsprice = (row.f_price_yb * row.f_num * row.f_rate)+row.f_pay_gs;
                                wsprice = parseFloat(this.keepTwoDecimal(wsprice));
                            //console.log(wsprice,'wsprice-infpay')
                            let more = wsprice+1;
                            let less = wsprice-1;
                            //console.log(more,'more');
                            //console.log(less,'less');
                            if(row.f_pay_ws<less||row.f_pay_ws>more){
                                this.$nextTick(()=>{
                                    row.f_pay_ws = wsprice;
                                    let payws = row.f_pay_ws-row.f_pay_gs;
                                    //console.log(payws,'完税-关税')
                                    let price = this.preciseDiv(payws, row.f_num);
                                        price = parseFloat(this.keepTwoDecimal(price));
                                    row.f_price_ws = price;
                                    let fzzs = row.f_pay_ws * row.f_sl;
                                        fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                    row.f_pay_zzs = fzzs;
                                })
                                this.$message.error(this.$t('invoiceEntry_the_dutiable_value_shall_not_exceed_or_be_less_than_the_established_price')+wsprice+"±1！");

                            }else{
                                let payws = row.f_pay_ws-row.f_pay_gs;
                                //console.log(payws,'完税-关税')
                                let price = this.preciseDiv(payws, row.f_num);
                                    price = parseFloat(this.keepTwoDecimal(price));
                                row.f_price_ws = price;
                                let fzzs = row.f_pay_ws * row.f_sl;
                                    fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                row.f_pay_zzs = fzzs;
                                this.$set(data,index,row);
                            }

                            //价税合计
                            let tp = 0;
                            let ts = 0;
                            data.map(item=>{
                                tp += item.f_pay_ws;
                                ts += item.f_pay_zzs;
                            })
                            this.f_pay_ws= parseFloat(this.keepTwoDecimal(tp));
                            this.f_pay_zzs= parseFloat(this.keepTwoDecimal(ts));
                            //this.totalPrice = parseFloat(this.keepTwoDecimal(tp)) + parseFloat(this.keepTwoDecimal(ts));
                            //this.totalPrice = parseFloat(this.keepTwoDecimal(tp+ts));
                            let num = this.keepTwoDecimal(tp+ts);
                            this.totalPrice = this.returnFloat(num);
                            this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                        }
                    }else{
                        if(row.f_pay_ws!=0){
                            let price = this.preciseDiv(row.f_pay_ws, row.f_num);
                                price = parseFloat(this.keepTwoDecimal(price));
                            row.f_price_ws = price;
                            let fzzs = row.f_pay_ws * row.f_sl;
                                fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                            row.f_pay_zzs = fzzs;
                            this.$set(data,index,row);
                            //价税合计
                            let tp = 0;
                            let ts = 0;
                            data.map(item=>{
                                tp += item.f_pay_ws;
                                ts += item.f_pay_zzs;
                            })
                            this.f_pay_ws= parseFloat(this.keepTwoDecimal(tp));
                            this.f_pay_zzs= parseFloat(this.keepTwoDecimal(ts));
                            //this.totalPrice = parseFloat(this.keepTwoDecimal(tp)) + parseFloat(this.keepTwoDecimal(ts));
                            //this.totalPrice = parseFloat(this.keepTwoDecimal(tp+ts));
                            let num = this.keepTwoDecimal(tp+ts);
                            this.totalPrice = this.returnFloat(num);
                            this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                        }
                    }

                }
            },
            returnFloat(num) {
                num = num.toString(); // 转成字符串类型  如能确定类型 这步可省去
                if (num.indexOf(".") !== -1) {
                    let [integerPart, decimalPart] = num.split(".");

                    if (decimalPart.length > 2) {
                        decimalPart = decimalPart.substring(0, 2);
                    } else if (decimalPart.length === 1) {
                        decimalPart += "0";
                    }

                    num = `${integerPart}.${decimalPart}`;
                } else {
                    num += ".00";
                }

                return num;
            },
            //除
            preciseDiv(dividend, divisor) {
                if(dividend&&divisor){
                    //console.log("////")
                    // 将除数和被除数转换为整数
                    const intDividend = parseFloat(dividend * 1000);
                    const intDivisor = parseFloat(divisor * 1000);
                    // 执行除法
                    const result = intDividend / intDivisor;
                    //console.log(result,'result------')
                    // 返回结果，注意这里需要再除以100，因为我们之前乘以了100
                    return result ;
                    /*// 将两个数转换成字符串，并以小数点为分隔
                    console.log('num1',num1)
                    console.log('num2',num2)
                    let num1Array = num1.toString().split('.');
                    let num2Array = num2.toString().split('.');
                    // 获取小数点后的长度，并计算乘放大的倍数
                    let num1DecimalLen = num1Array.length === 1 ? 0 : num1Array[1].length;
                    let num2DecimalLen = num2Array.length === 1 ? 0 : num2Array[1].length;
                    let scale = Math.pow(10, Math.max(num1DecimalLen, num2DecimalLen));
                    // 乘以放大倍数进行计算，并结果舍入保留整数
                    let precisionProduct = (num1 * scale) / (num2 * scale);
                    // 返回结果时再除以相同的放大倍数获取正确的浮点数结果
                    return precisionProduct / scale;*/
                }

            },
            //bu0
            buzero(result){
                let result1 = result+'';
                if(result1.indexOf('.')=='-1'){
                    result1 = result1+'.00'
                }
                return result1
            },
            keepTwoDecimal(num) {
                var result = parseFloat(num);
                if (isNaN(result)) {
                    result = 0;
                }else{
                    result = Math.round(num * 100) / 100;//保留两位

                }
                return result;
            },
            saveForm(){
                //console.log(this.formData.files,'files')
                //console.log(this.isred,'this.isred')
                if(this.orderWs==''&&this.i_isfrom==1){
                    this.$message.error(this.$t('invoiceEntry_please_select_an_order_first')+'!');
                }
                if(this.i_isfrom==0&&this.type=='add'){
                    if(this.formData.files.length==0){
                        this.$message.error(this.$t('invoiceEntry_please_upload_the_attachment'));
                        return ;
                    }
                }
                if(this.i_fptype==null){
                    this.$message.error(this.$t('invoiceEntry_please_enter_invoice_type')+'!');
                    return ;
                }
                if(this.formData.vc_fpcode==''&&this.i_isfrom==1){
                    this.$message.error(this.$t('invoiceEntry_please_enter_invoice_number')+'!');
                    return ;
                }
                if(this.i_kpkhid==0){
                    this.$message.error(this.$t('invoiceEntry_please_select_the_invoicing_party')+'!');
                    return ;
                }
                if(this.formData.dt_fptime==''||!this.formData.dt_fptime){
                    this.$message.error(this.$t('invoiceEntry_please_select_the_invoicing_time')+'!');
                    return ;
                }
                if(this.companyId==0){
                    this.$message.error(this.$t('invoiceEntry_please_select_the_buyer')+'!');
                    return ;
                }
                if(this.i_isagent==1&&this.xsComId==0){
                    this.$message.error(this.$t('invoiceEntry_please_select_the_seller')+'!');
                    return ;
                }
                if (this.tableData.length==0){
                    this.$message.error(this.$t('invoiceEntry_please_select_invoice_type')+'!');
                    return ;
                }else{
                    let kong = this.tableData.some(item=>{
                        return item.f_num==0||item.f_pay_ws==0 //||item.f_pay_zzs==0
                    })
                    //console.log('kong',kong)
                    if(kong){
                        this.$message.error(this.$t('invoiceEntry_the_number_of_varieties/tax-free_amount_is_0')); ///税额
                        return ;
                    }else{
                        /*this.tableData = this.tableData.filter(item=>{
                            return item.vc_pzname!=''
                        })*/
                        let pmkong = this.tableData.some(item=>{
                            return item.vc_pzname==''
                        })
                    }
                    //console.log('tableData',this.tableData )
                }
                if(this.i_isfrom==1){
                    //console.log('fptotalPrice',this.fptotalPrice)
                    //价税合计
                    let tp = 0;
                    let ts = 0;
                    this.tableData.map(item=>{
                        tp += item.f_pay_ws;
                        ts += item.f_pay_zzs;
                    });
                    this.f_pay_ws= parseFloat(this.keepTwoDecimal(tp));
                    this.f_pay_zzs= parseFloat(this.keepTwoDecimal(ts));
                    //this.totalPrice = parseFloat(this.keepTwoDecimal(tp)) + parseFloat(this.keepTwoDecimal(ts));
                    //this.totalPrice = parseFloat(this.keepTwoDecimal(tp+ts));
                    let num = this.keepTwoDecimal(tp+ts);
                    this.totalPrice = this.returnFloat(num);
                    this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                    /*tp= parseFloat(this.keepTwoDecimal(tp));
                    ts= parseFloat(this.keepTwoDecimal(ts));
                    let sumPrice = tp + ts;
                    console.log('sumPrice',sumPrice)*/
                    //console.log('totalPrice',this.totalPrice)
                    if(parseFloat(this.totalPrice)!=this.fptotalPrice){
                        let title = this.$t('invoiceEntry_the_inclusive_tax_amount_is_inconsistent_with_the_original_invoice_amount',[this.fptotalPrice]);
                        // let title = '价税金额与原发票金额'+this.fptotalPrice+'不一致！';
                        this.$message.error(title);
                        return;
                    }
                }
                //return;
                this.save();
            },
            //保存
            async save(){
                this.disinput_fpcode=true;
                this.disinput2=true;//daikai/xiaoshou
                this.disinput=true;//禁下拉输入
                this.disabled=true;//禁保存
                this.isbtn=true;//禁减号
                this.isedit=true;//禁单选
                this.loading=true;
                let param={
                    "i_id": this.i_id,
                    "i_type": this.i_type, //发票类型，2：采购发票， 3： 运费发票 ，32：港杂发票， 4：开证发票 ， 5： 仓储发票 ， 6：保险发票
                    'i_khtype':this.i_khtype==4?2:this.i_khtype,
                    'i_fptype':this.i_fptype,
                    'vc_fptype':this.vc_fptype,
                    "vc_fpcode": this.formData.vc_fpcode,//发票编号,
                    "i_kpkhid": this.i_isagent==1?this.xsComId:this.i_kpkhid , //销售方，代开时为销售方，非代开时为开票方
                    "vc_kpkhname":this.i_isagent==1?this.xsComname:this.vc_kpkhname ,//开票方
                    "vc_khcreditcode":this.vc_khcreditcode, //开票方识别号
                    "vc_gscreditcode":this.vc_gscreditcode, //开票方识别号
                    "dt_fptime":this.formData.dt_fptime, //开票日期
                    "i_gsid":this.companyId,
                    "vc_gsname": this.companyName,
                    "i_isagent":this.i_isagent, //是否代开，1是0否
                    'i_dkable':this.isdk,
                    "i_dlkhid": this.i_isagent==1?this.i_kpkhid:0 ,
                    "vc_dlkhname":this.i_isagent==1?this.vc_kpkhname:'' , //代理开票方,
                    "f_pay": parseFloat(this.totalPrice), //开票金额
                    "f_pay_ws": this.f_pay_ws,
                    "f_pay_zzs": this.f_pay_zzs,
                    "vc_note": this.formData.vc_note,
                    "i_isfrom": this.i_isfrom, //来源，0来源于税务云，1来源于员工上传
                    "vc_mainfile_newname":this.i_isfrom==0&&this.type=='add'?this.formData.files[0].vc_path:this.vc_newname,//发票上传附件的newname
                    //"vc_mainfile_newname":this.vc_newname,
                    'details':this.tableData,
                    "delIds":this.delIds,
                    'vc_fkey':this.i_isfrom==1?this.vc_fkey:"",
                    'vc_no':this.orderWs,
                    'i_gid':sessionStorage.getItem("i_gid"),
                    'i_bzid_yb':this.i_bzid_yb,
                    //'invoiceType':this.isred?2:1,
                    'i_invoiceType':this.i_invoiceType,
                    'vc_relateinvoice_code':this.i_invoiceType==2?this.copyfpcode:null,
                    'i_glfpid':this.i_invoiceType==2?this.i_glfpid:null,
                };
                //return;
                let res=await API.save(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.isshua=1;
                    this.type='edit';
                    this.disabled=false;
                    this.i_id=res.data;
                    //this.isover=res.data.isover;
                    this.detail()
                    //this.cancel('1');
                }else if (res.code == -2) {
                    this.disinput_fpcode=false;
                    this.disinput2=false;//daikai/xiaoshou
                    this.disinput=false;//禁下拉输入
                    this.disabled=false;//禁保存
                    this.isbtn=false;//禁减号
                    this.isedit=false;//禁单选
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disinput_fpcode=false;
                    this.disinput2=false;//daikai/xiaoshou
                    this.disinput=false;//禁下拉输入
                    this.disabled=false;//禁保存
                    this.isbtn=false;//禁减号
                    this.isedit=false;//禁单选
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            cancel(val){
                this.delIds=[];
                this.$emit('cancelDialog',val);


            },
            openpm(data,index,row){
                //console.log(row,index,'-')
                if(this.orderWs==''&&this.i_isfrom==1){
                    this.$message.error(this.$t('invoiceEntry_please_select_an_order_first')+'!');
                }else{
                    //if(row.vc_pzname==''){
                        //console.log('row.vc_pzname',row.vc_pzname);
                        this.productDetails={
                            i_type:this.i_type,
                            i_khtype:this.i_isagent==1?2:this.i_khtype,
                            i_kpkhid: this.i_isagent==1?this.xsComId:this.i_kpkhid ,
                            i_gsid:this.companyId,
                            vc_search: '',
                            index:index,
                            row:row,
                            selected:this.selectD,
                            orderWs:this.orderWs,
                            i_isfrom:this.i_isfrom,
                        }
                        this.tableData[index].visible=true;
                        if (this.tableData[index].visible==true){
                            this.isbtn=true
                        }
                    //}
                }

            },
            popShow(){
                let map={
                    vc_pzname:"",
                    visible:false,
                    f_rate:1,
                    f_sl:this.f_sl,
                };
                //this.tableData.unshift(map);
                this.tableData.push(map);
                //console.log('this.tableData',this.tableData);
            },
            closePop(index,len){
                //console.log('index',index)

                if(index<this.tableData.length){
                    if(len==1){
                        this.tableData[index].visible=false;
                    }else{
                        this.tableData.map(item=>{
                            item.visible=false
                        })
                    }

                }else{
                    this.tableData.map(item=>{
                        item.visible=false
                    })
                }
                if(!index){
                    this.tableData.map(item=>{
                        item.visible=false
                    })
                }
                this.productDetails={};
                this.isbtn=false;
            },
            //根据i_pzid拆分数组
            splitArrayByKey(arr, key) {
                return arr.reduce((acc, obj) => {
                    const value = obj[key];
                    if (!acc.hasOwnProperty(value)) {
                        acc[value] = [];
                    }
                    acc[value].push(obj);
                    return acc;
                }, {});
            },
            replaceDuplicateValuesWithEmptyString(arr, key) {
                let seenValues = new Set();
                return arr.map(obj => {
                    let value = obj[key];
                    if (seenValues.has(value)) {
                        obj[key] = ''; // 将重复的值替换为空字符串
                    } else {
                        seenValues.add(value); // 将第一次出现的值添加到集合中
                    }
                    return obj;
                });
            },
            //产品列表
            transValue(value,index,row){
                //console.log("value----",value)
                //console.log("row----",row)
                this.closePop(index,value.length);
                if(value.length!=0){
                    value.map(item=>{
                        if(this.i_isfrom==1){
                            item.vc_fppzname=row.vc_fppzname;
                            item.vc_fpbzstyle=row.vc_fpbzstyle;
                            item.vc_fpunit=row.vc_fpunit;
                            item.f_fpnum=row.f_fpnum;
                            item.f_fpprice=row.f_fpprice;
                            item.f_fppay_ws= row.f_fppay_ws;
                            item.f_fppay_zzs=row.f_fppay_zzs;
                            item.vc_pzname=item.vc_pzname;
                            item.f_num=item.change?item.f_num:item.f_fpnum;
                            item.f_price_ws=item.change?item.f_price_ws:item.f_fpprice;
                            item.f_pay_ws=item.change?item.f_pay_ws:item.f_fppay_ws;
                            item.f_pay_zzs=item.change?item.f_pay_zzs:item.f_fppay_zzs;
                            item.i_pzid=item.i_pzid;
                            item.i_id=0;
                            item.visible=false;
                            item.f_rate=1;
                            item.f_sl=this.f_sl;
                            //
                            item.shib=item.i_pzid+item.vc_fppzname;
                        }else{
                            item.vc_fppzname='';
                            item.vc_pzname=item.vc_pzname;
                            item.f_num=0;
                            item.f_price_ws=0;
                            item.f_pay_ws=0;
                            item.f_pay_zzs=0;
                            item.i_pzid=item.i_pzid;
                            item.i_id=0;
                            item.visible=false;
                            item.f_rate=1;
                            item.f_sl=this.f_sl;
                            //
                            item.shib=item.i_pzid+item.vc_pzname;
                        }
                    });
                    if(value.length==1){
                        this.tableData.splice(index,1,...value);
                        //console.log('this.tableData',this.tableData)
                    }else{
                        //value[0].vc_fkey_sub = row.vc_fkey_sub;
                        this.tableData.splice(index,1,...value);
                        //console.log('this.tableData',this.tableData);
                        //console.log('this.yuanshi',this.yuanshi);
                    }
                   /* console.log(this.tableData,'this.tableData')
                    console.log(value,'value')
                    value[0].vc_fkey_sub = row.vc_fkey_sub;
                    this.tableData.splice(index,1,...value);
                    console.log('this.tableData',this.tableData);*/
                    let arr = this.deepClone(this.tableData) ;
                    //console.log('arr',arr);
                    let hash = {};
                    arr = arr.reduce(function(item, next) {
                        //hash[next.uniqueKey] ? '' : hash[next.uniqueKey] = true && item.push(next);
                        //hash[next.i_pzid+'/'+next.vc_pzname+'/'+next.vc_cd+'/'+next.vc_gykh+'/'+next.vc_bzstyle] ? '' : hash[next.i_pzid+'/'+next.vc_pzname+'/'+next.vc_cd+'/'+next.vc_gykh+'/'+next.vc_bzstyle] = true && item.push(next);
                        hash[next.i_pzid+'/'+next.vc_fppzname] ? '' : hash[next.i_pzid+'/'+next.vc_fppzname] = true && item.push(next);
                        return item
                    }, []);
                    //console.log("arr--",arr);
                    if(this.i_isfrom==1){
                        arr.map((item,index)=>{
                            this.yuanshi.map((ysitem,ysindex)=>{
                                if(item.vc_fppzname==ysitem.vc_fppzname) {
                                    return item.vc_fkey_sub = ysitem.vc_fkey_sub
                                }
                            })
                        });
                        //console.log("arr---",arr);
                        const newarr =  this.replaceDuplicateValuesWithEmptyString(arr, 'vc_fkey_sub');
                        //console.log("newarr----",newarr);
                        this.formData.tableData=newarr;
                        this.tableData=newarr;
                        //this.selectD=value;
                        this.selectD=[];
                        //this.productDetails.selected=this.tableData;
                    }else{
                        this.formData.tableData=arr;
                        this.tableData=arr;
                        this.selectD=value;
                        //this.productDetails.selected=this.tableData;
                    }

                }
                /*if(value.length!=0){
                    this.tableData.splice(index,1);
                    value.map(item=>{
                        if(this.i_isfrom==1){
                            item.vc_fppzname=row.vc_fppzname;
                            item.vc_fpbzstyle=row.vc_fpbzstyle
                            item.vc_fpunit=row.vc_fpunit
                            item.f_fpnum=row.f_fpnum
                            item.f_fpprice=row.f_fpprice
                            item.f_fppay_ws= row.f_fppay_ws
                            item.f_fppay_zzs=row.f_fppay_zzs
                        }
                        item.vc_pzname=item.vc_name;
                        item.f_num=0;
                        item.f_price_ws=0;
                        item.f_pay_ws=0;
                        item.f_pay_zzs=0;
                        item.i_pzid=item.i_id;
                        item.i_id=0;
                        item.visible=false;
                        item.f_rate=1;
                        item.f_sl=this.f_sl;
                    });
                    let arr=[...this.tableData , ...value ];
                    console.log(arr,"arrrrrrrrrrrrr");
                    let hash = {};
                    arr = arr.reduce(function(item, next) {
                        //hash[next.i_id] ? '' : hash[next.i_id] = true && item.push(next);
                        hash[next.i_pzid+'/'+next.vc_pzname+'/'+next.vc_cd+'/'+next.vc_gykh+'/'+next.vc_bzstyle] ? '' : hash[next.i_pzid+'/'+next.vc_pzname+'/'+next.vc_cd+'/'+next.vc_gykh+'/'+next.vc_bzstyle] = true && item.push(next);
                        return item
                    }, []);
                    console.log("arr--",arr)
                    //return;
                    this.formData.tableData=arr;
                    this.tableData=arr;
                    this.productDetails.selected=this.tableData;
                }*/

            },
            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            deleteRow(value,index){
                //console.log('this.isbtn',this.isbtn)
                if(!this.isbtn){
                    this.tableData.splice(index,1);
                    if(value.i_id){
                        this.delIds.push(value.i_id);
                        //console.log('this.delIds',this.delIds)
                    };
                    //console.log(this.tableData,'this.tableData---')
                    //价税合计
                    let tp = 0;
                    let ts = 0;
                    this.tableData.map(item=>{
                        tp += item.f_pay_ws;
                        ts += item.f_pay_zzs;
                    });
                    this.f_pay_ws= parseFloat(this.keepTwoDecimal(tp));
                    this.f_pay_zzs= parseFloat(this.keepTwoDecimal(ts));
                    //this.totalPrice = parseFloat(this.keepTwoDecimal(tp)) + parseFloat(this.keepTwoDecimal(ts));
                    //this.totalPrice = parseFloat(this.keepTwoDecimal(tp+ts));
                    let num = this.keepTwoDecimal(tp+ts);
                    this.totalPrice = this.returnFloat(num);
                    this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.dt_createtime=`${date.getFullYear()}-${month}-${strDate}`;
            },
            choosedk(e){
                this.i_isagent=e;
                if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isagent==1){
                    this.getKhByKz();
                }
            },
            //销售方
            async getKhByKz(){
                let param = {
                    i_gsid:this.companyId,
                    i_dlkhid:this.i_kpkhid,
                    i_mid:this.mid,
                };
                let res = await API.getKhByKz(param);
                if (res.code == 1) {
                    this.xsData = res.data.list;

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //根据开票方获取发票编号列表
            async beforehandle(){
                let param = {
                    'i_mid':this.mid,
                    'vc_kpkhname':this.vc_kpkhname,
                    'vc_khcreditcode':this.vc_khcreditcode,
                    'vc_gsname':this.companyName,
                    'vc_gscreditcode':this.vc_gscreditcode,

                };
                let res = await API.beforehandle(param);
                if (res.code == 1) {
                    this.codeData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //发票类型
            async fplx(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.fplx(param);
                if (res.code == 1) {
                    this.fplxData = res.data.list;
                    this.i_fptype = res.data.list[0].i_id;
                    this.vc_fptype = res.data.list[0].vc_name;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取交易公司
            async getCompanyList(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //查询开票类型
            async fptype(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.fptype(param);
                if (res.code == 1) {
                    this.fpType = res.data.list;
                    this.i_type = res.data.list[0].i_id;
                    this.vc_type = res.data.list[0].vc_name;
                    this.i_khtype = res.data.list[0].i_khtype;
                    this.i_origin_khtype = res.data.list[0].i_origin_khtype;
                    this.vc_fymx = res.data.list[0].vc_fymx;
                    //this.i_isagent = res.data.list[0].i_isagent;
                    this.isdk = res.data.list[0].i_dkable;
                    this.i_issd=res.data.list[0].i_issd;
                    this.i_flag=res.data.list[0].i_flag;
                    this.f_sl = res.data.list[0].f_sl;
                    this.getkhlist();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取开票方
            async getkhlist(){
                let param = {
                    vc_search:'',
                    i_khtype:this.i_khtype,
                };
                let res = await API.getkhlist(param);
                if (res.code == 1) {
                    this.kpfData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            yanzheng(){
                if(this.i_kpkhid==0){
                    this.$message.error(this.$t('invoiceEntry_please_select_the_invoicing_party_first')+'!');
                    return;
                }
                if(this.companyId==0){
                    this.$message.error(this.$t('invoiceEntry_please_select_the_buyer_first')+'!');
                    return;
                }

            },
            changeData(e,type){
                if(this.i_isfrom==0){
                    this.tableData=[];
                    this.orderWs='';
                    this.orderids=[];
                }
                //console.log(e,type);
                if(type=='bz'){
                    this.i_bzid=e;
                    let choo = this.bzData.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_bzname=choo[0].vc_name;
                        this.f_rate=choo[0].f_rate;
                    }else{
                        this.vc_bzname='';
                        this.f_rate=0;
                    }
                }
                if(type=='fpt'){
                    this.i_type=e;
                    let choo = this.fpType.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_type=choo[0].vc_name;
                        this.i_khtype=choo[0].i_khtype;
                        this.i_origin_khtype = choo[0].i_origin_khtype;
                        this.vc_fymx = choo[0].vc_fymx;
                        //this.i_isagent=choo[0].i_isagent;
                        this.isdk=choo[0].i_dkable;
                        this.i_issd=choo[0].i_issd;
                        this.i_flag=choo[0].i_flag;
                        this.f_sl=choo[0].f_sl;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                        this.getkhlist();
                        /*if(this.i_flag==1&&this.i_isfrom==0){
                            this.getbzlist();
                        }*/
                    }else{
                        this.vc_type='';
                        this.i_khtype=0;
                        this.i_origin_khtype=0;
                        this.vc_fymx='';
                        //this.i_isagent=0;
                        this.isdk=0;
                        this.i_issd=0;
                        this.i_flag=0;
                        this.f_sl=0;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                    }

                }
                if(type=='state'){
                    this.isover=e;
                    let choo = this.stateData.filter(item=>{
                        return item.isover == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.vc_isover=choo[0].vc_name;
                    }else{
                        this.vc_isover='';
                    }
                }
                if(type=='kpf'){
                    if(this.i_khtype==0){
                        this.$message.error(this.$t('invoiceEntry_please_select_the_invoice_type_first'));
                    }else{
                        this.i_kpkhid=e;
                        let choo = this.kpfData.filter(item=>{
                            return item.i_id == e
                        });
                        //console.log(choo,'choo');
                        if(choo.length>0){
                            this.vc_kpkhname=choo[0].vc_name;
                            this.vc_khcreditcode=choo[0].vc_creditcode;
                            this.xsData=[];
                            this.xsComname='';
                            this.xsComId=0;
                        }else{
                            this.vc_kpkhname='';
                            this.vc_khcreditcode='';
                            this.xsData=[];
                            this.xsComname='';
                            this.xsComId=0;
                        }
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isagent==1){
                        this.getKhByKz();
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isfrom==1){
                        this.beforehandle();
                    }
                }
                if(type=='gs'){
                    this.companyId=e;
                    let choo = this.compsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.companyName=choo[0].vc_name;
                        this.vc_gscreditcode=choo[0].vc_creditcode;
                        this.xsData=[];
                        this.xsComname='';
                        this.xsComId=0;
                    }else{
                        this.companyName='';
                        this.vc_gscreditcode='';
                        this.xsData=[];
                        this.xsComname='';
                        this.xsComId=0;
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isagent==1){
                        this.getKhByKz();
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isfrom==1){
                        this.beforehandle();
                    }
                }
                if(type=='xs'){
                    this.xsComId=e;
                    let choo = this.xsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.xsComname=choo[0].vc_name;
                        this.vc_khcreditcode=choo[0].vc_creditcode;
                    }else{
                        this.xsComname='';
                        this.vc_khcreditcode='';
                    }
                }
                if(type=='fplx'){
                    this.i_fptype=e;
                    let choo = this.fplxData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.vc_fptype=choo[0].vc_name;
                    }else{
                        this.vc_fptype='';
                    }
                }
                if(type=='code'){
                    this.vc_fkey = e;
                    if(this.vc_fkey!=0){
                        this.beforedetail()
                    }

                }


            },
            clearsearch(type){
                if(this.i_isfrom==0){
                    this.tableData=[];
                    this.orderWs='';
                    this.orderids=[];
                }
                if(type=='bz'){
                    this.i_bzid=0;
                    this.vc_bzname='';
                    this.f_rate=0;
                }
                if(type=='fpt') {
                    this.i_type=0;
                    this.vc_type='';
                    this.i_khtype = 0;
                    this.i_origin_khtype=0;
                    this.vc_fymx='';
                    this.i_issd=0;
                    this.i_flag=0;
                    this.f_sl=0;
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                    this.kpfData=[];
                }
                if(type=='state'){
                    this.isover=null;
                    this.vc_isover='';
                }
                if(type=='kpf') {
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                    this.vc_khcreditcode='';
                }
                if(type=='gs'){
                    this.companyId=0;
                    this.companyName="";
                    this.vc_gscreditcode='';
                }
                if(type=='sou'){
                    this.vc_search=""
                }
                if(type=='xs'){
                    this.xsComId=0;
                    this.xsComname='';
                    this.vc_khcreditcode='';
                }
                if(type=='fplx'){
                    this.i_fptype=null;
                    this.vc_fptype='';

                }
                if(type=='code'){
                    this.vc_fkey = 0;
                }

            },
            // 小写金额转化为大写金额
            convertToChineseCapital(val){
                let cnNums = ['零','壹','贰','叁','肆','伍','陆','柒','捌','玖'] //汉字数字
                let cnIntRadice = ['','拾','佰','仟']  //基本单位
                let cnIntUnits = ['元','万','亿','兆'] //整数部分扩展单位
                let cnDecUnits = ['角','分','毫','厘'] //小数部分扩展单位
                // let cnInteger = '整'
                let cnIntLast = '元'
                let integerNum  //金额的整数部分
                let decimalNum  //金额的小数部分
                let chineseStr = '' //输出的中文金额字符串
                let parts; //分离金额后用的数组
                if(val== ''){
                    return ''
                }
                if(val == 0){
                    // return cnNums[0] + cnIntLast + cnInteger
                    return cnNums[0] + cnIntLast
                }
                // 转化为字符串
                val = val + ''
                if(val.indexOf('.') == -1){
                    integerNum = val
                    decimalNum = ''
                }else{
                    parts = val.split('.')
                    integerNum = parts[0]
                    decimalNum = parts[1].substr(0,4)
                }
                // 获取整形部分转化
                if(parseInt(integerNum,10)>0){
                    let zeroCount = 0
                    let IntLen = integerNum.length
                    for(let i=0;i<IntLen;i++){
                        let n = integerNum.substr(i,1)
                        let p = IntLen - i - 1
                        let q = p / 4
                        let m = p % 4
                        if(n == 0){
                            zeroCount ++
                        }else{
                            if(zeroCount > 0){
                                chineseStr += cnNums[0]
                            }
                            // 归0
                            zeroCount = 0
                            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
                        }
                        if(m==0 && zeroCount<4){
                            chineseStr += cnIntUnits[q]
                        }

                    }
                    // chineseStr += cnIntLast
                }
                // 小数部分
                if(decimalNum != ''){
                    let decLen = decimalNum.length
                    for(let i=0;i<decLen;i++){
                        let n = decimalNum.substr(i,1)
                        if(n != 0){
                            chineseStr+=cnNums[Number(n)]+cnDecUnits[i]
                        }
                    }
                }
                if(chineseStr == ''){
                    // chineseStr += cnNums[0]+ cnIntLast + cnInteger
                    chineseStr += cnNums[0]+ cnIntLast
                }else if(decimalNum == ''){
                    // chineseStr += cnInteger
                    chineseStr += ''
                }
                return chineseStr
            },

        },
    }
</script>

<style  lang="scss" scoped>
    /deep/.dis .el-loading-spinner .circular{
        display: none;
    }

    /deep/ .el-radio__original {
        display: none !important; /* 隐藏原生 radio 输入，但仍然允许交互 */
    }

    /deep/.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
        box-shadow: none !important;
    }
    .pad10{
        padding: 0 10px;
    }
    .fppm{
        max-height: 40px; /* 根据需要设置占位的行高 × 行数 */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 2; /* 显示的行数 */
        -webkit-box-orient: vertical;
    }
    .ale{
        align-items: end;
    }
    .img-box {
        margin: 0px;

        .uploadPhone {
            width: 70px;
            height: 80px;
            position: relative;
            width: 100%;
        }

        .uploadPhone img {
            width: 70px;
            height: 80px;
        }

        .upload-box {
            width: 30%;
            height: 30%;
        }

        .upload-input {
            position: absolute;
            opacity: 0;
            width: 70px;
            height: 80px;
        }
    }
    /deep/{
        .el-dialog__body{
            padding: 6px 10px !important;
        }
    }
    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: #3e82e8 !important;
    }
    .red{
        color: #3e82e8 !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .border{
        border: 1px solid #e1e1e1;
        line-height: 24px;
        height: 24px;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
</style>